import MyInvestmentsPortfolio from './container';

export default MyInvestmentsPortfolio;
